import { render, staticRenderFns } from "./addLimit.vue?vue&type=template&id=0cbf705e"
import script from "./addLimit.vue?vue&type=script&lang=js"
export * from "./addLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports